module.exports = __webpack_public_path__ + "media/images/icons/filled/trademark-circle-9bf3d6dff97d4c9521461b9426cc1f70.svg";